import { toast as _toast, ToastOptions } from 'react-toastify';

/**
 * Wraps react-toastify's `toast` and enforces that error toasts are always
 * persistent (no auto-close, no progress bar) so the user must dismiss them
 * manually. All other toast methods behave exactly as the original.
 */
export const toast = Object.assign(
  (...args: Parameters<typeof _toast>) => _toast(...args),
  _toast,
  {
    error: (
      content: Parameters<typeof _toast.error>[0],
      options?: ToastOptions
    ) =>
      _toast.error(content, {
        ...options,
        autoClose: false,
        hideProgressBar: true,
      }),
  }
);
